// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3YJPF","colMin":"styles_colMin__12u1p","colCheckbox":"styles_colCheckbox__3jvz_"};